<template>
  <div class="container">
    <h4>Certificado digital</h4>
    <div class="row">
      <div class="col col-md-12">
        <p>
          Cada vez que firmes digitalmente un documento, la estampa visual que se insertará en el
          documento, se verá tal como la configures aquí, para ello, tienes varias opciones,
          selecciona la que tu organización ha instruido o, si lo tienes permitido, seleccionar la
          que mas te acomode.
        </p>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col col-md-12">
        <h4>PLANTILLA</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p>
          En el siguiente recuadro puedes escribir lo que se vera en tu firma, y mas abajo podras
          ver de forma instantanea el
          resultado final. Puedes usar algunas palabras clave que contienen información, podrian ser
          de utilidad a la hora de armar
          la plantilla de tu firma. Debes tener presente que el espacio disponible para escribir es
          limitado, solo pueden ser 5 lineas
          de texto. Cuidado con el largo de cada linea, ya que si no hay espacio suficiente, las
          palabras sobrantes pasarán a la siguiente linea.
        </p>
      </div>
      <div class="col-md-6 col-sm-12">
        <textarea
          class="form-control"
          rows="5"
          cols="80"
          v-model="configurations.textTemplate"
          ng-change="renderizarPlantillaSoloTexto()"
          style="font-size: 14px"
        >
        </textarea>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="only_text"
            :value="configType.onlyText"
            v-model="configurations.templateType"
          >
          <label class="form-check-label" for="only_text">
            Solo Texto
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="draw"
            :value="configType.draw"
            v-model=configurations.templateType
          >
          <label class="form-check-label" for="draw">
            Dibujar mi Firma
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="atached"
            :value="configType.atached"
            v-model=configurations.templateType
          >
          <label class="form-check-label" for="atached">
            Subir mi firma
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="desing"
            :value="configType.desing"
            v-model=configurations.templateType
          >
          <label class="form-check-label" for="desing">
            Diseñar mi firma
          </label>
        </div>
      </div>
    </div>
    <br>
    <div class="row" v-if="configurations.templateType === configType.onlyText">
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3">
        <SignaturePreview :configurations="configurations" :user="user" :company="company"/>
      </div>
    </div>
    <div class="row" v-if="configurations.templateType === configType.atached">
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12">
        <FileSignatureSelector @input="setDrawImage"/>
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3">
        <SignaturePreview :configurations="configurations" :user="user" :company="company"/>
      </div>
    </div>
    <div class="row" v-if="configurations.templateType === configType.desing">
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12">
        <input
          class="form-control"
          v-model="configurations.emulation"
        />
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3">
        <SignaturePreview :configurations="configurations" :user="user" :company="company"/>
      </div>
    </div>
    <div class="row" v-if="configurations.templateType === configType.draw">
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12">
        <SignaturePad @input="setDrawImage"/>
        <span>Nota: Si no se actualiza la imagen, no se reflejara al guardar los cambios</span>
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3">
        <SignaturePreview :configurations="configurations" :user="user" :company="company"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import SignaturePad from '@/febos/global/usuario/components/sign/simple/febos/SignaturePad';
import { configType } from '@/febos/global/usuario/components/sign/simple/febos/constants';
import SignaturePreview from '@/febos/global/usuario/components/sign/simple/febos/SignaturePreview';
import FileSignatureSelector
  from '@/febos/global/usuario/components/sign/simple/febos/FileSignatureSelector';

export default {
  name: 'ConfigureSign',
  components: { FileSignatureSelector, SignaturePreview, SignaturePad },
  data() {
    return {
      configType
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    setDrawImage({ png }) {
      this.configurations.respresentation = png;
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    configurations: {
      type: Object,
      required: true
    }
  }
};
</script>
